import { supplychainAxios } from 'Utility/api';

export const getBatchHierarchy = batchId => supplychainAxios.get(`/batches/hierarchy/${batchId}`);
